// extracted by mini-css-extract-plugin
module.exports = {"email":"UnverifiedStaffAccountScreen_email__3HB9a","footer":"UnverifiedStaffAccountScreen_footer__NRVm9","resendEmail":"UnverifiedStaffAccountScreen_resendEmail__14COg"};